export const dimension = 25
export const canvasDimension = 500
export const cellDimension = canvasDimension / dimension